import PortalIdParser from 'PortalIdParser';
export const getRecordHref = (objectTypeId, objectId) => {
  if ('0-54' === objectTypeId) {
    return `/marketing-events/${PortalIdParser.get()}/details/${objectId}`;
  }
  return `/contacts/${PortalIdParser.get()}/record/${encodeURIComponent(objectTypeId)}/${encodeURIComponent(objectId)}`;
};